import React, { useState, useEffect } from 'react';
import WilayaDropdown from '@/components/WilayaDropdown';
import StatusDropdown from './StatusDropdown';
import CollectorDropDown from '@/components/CollectorDropDown';
import { DateRangePicker } from '@/components/DateRangePicker';
import { DateRange } from 'react-day-picker';
import {
  Dialog,
  DialogContent,
  DialogHeader,
  DialogTitle,
  DialogTrigger,
} from '@/components/ui/dialog';
import { Button } from '@/components/ui/button';
import { Label } from '@/components/ui/label';

type FiltersProps = {
  collectorIdExist: boolean;
  onFiltersChange: (filters: {
    status: string;
    selectedCollector: string;
    dateRange: DateRange | undefined;
  }) => void;
};

const Filters: React.FC<FiltersProps> = ({
  onFiltersChange,
  collectorIdExist,
}) => {
  const [isOpen, setIsOpen] = useState(false);
  const [status, setStatus] = useState<string>('');
  const [collector, setCollector] = useState<Employee>();
  const [selectedCollector, setSelectedCollector] = useState<string>('');
  const [dateRange, setDateRange] = useState<DateRange | undefined>(undefined);

  // Mobile: Call onFiltersChange only when "Apply Filters" is pressed
  const handleSave = () => {
    onFiltersChange({
      status,
      selectedCollector,
      dateRange,
    });
    setIsOpen(false);
  };

  // Desktop: Immediately call onFiltersChange when any filter changes
  useEffect(() => {
    if (!isOpen) {
      // To avoid triggering the fetch on mobile when dialog is open
      onFiltersChange({
        status,
        selectedCollector,
        dateRange,
      });
    }
  }, [status, selectedCollector, dateRange, isOpen]);

  const FiltersContent = () => (
    <div className='flex flex-col md:flex-row items-center md:space-x-4 md:space-y-0 space-y-4'>
      <div className='w-full mt-8 md:mt-0'>
        <Label className='md:hidden'>Status</Label>
        <StatusDropdown
          value={status}
          onValueChange={(value) => setStatus(value === 'all' ? '' : value)}
        />
      </div>

      {!collectorIdExist && (
        <div className='w-full'>
          <Label className='md:hidden'>Collector</Label>
          <CollectorDropDown
            isFilter
            value={collector?.fullname || ''}
            collector={collector}
            onValueChange={(value: string) => {
              const parsedObject = value === 'all' ? 'all' : JSON.parse(value);
              setCollector(parsedObject === 'all' ? '' : parsedObject);
              setSelectedCollector(
                parsedObject === 'all' ? '' : parsedObject.id
              );
            }}
          />
        </div>
      )}

      <div className='w-full'>
        <Label className='md:hidden'>Date</Label>
        <DateRangePicker
          className='w-full '
          date={dateRange}
          onDateChange={setDateRange}
        />
      </div>
    </div>
  );

  return (
    <>
      {/* Mobile view */}
      <div className='md:hidden'>
        <Dialog open={isOpen} onOpenChange={setIsOpen}>
          <DialogTrigger asChild>
            <Button
              variant='outline'
              className='w-full text-muted-foreground border-muted-foreground rounded-xl'
            >
              Filters
            </Button>
          </DialogTrigger>
          <DialogContent className='h-screen flex flex-col w-full'>
            <DialogHeader>
              <DialogTitle>Filters</DialogTitle>
            </DialogHeader>
            <FiltersContent />
            <Button onClick={handleSave} className='w-full mt-auto'>
              Apply Filters
            </Button>
          </DialogContent>
        </Dialog>
      </div>

      {/* Desktop view */}
      <div className='hidden md:flex md:items-center md:space-x-4'>
        <FiltersContent />
      </div>
    </>
  );
};

export default Filters;
